import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { ContractCapability } from '../../_types/contract-capability';
import { ContractCapabilitiesService } from '../../_services/contracts-capabilities.service';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { ContractTransactionSerie } from '../../_types/contract-transaction-serie';
import { ContractTransactionSeriesService } from '../../_services/contracts-transactions-series.service';
import { TransactionsSeriesService } from 'src/app/modules/transactions-series/_services/transactions-series.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-contract-transaction-series-detail',
    templateUrl: './transaction-series-detail.component.html',
    styleUrls: ['./transaction-series-detail.component.scss'],
    standalone: false
})
export class ContractTransactionSeriesDetailComponent {
  public contractTransactionSerieFormGroup!: RxFormGroup;

  public contractTransactionSerie: ContractTransactionSerie = new ContractTransactionSerie();
  public transactionSeries: any[] = [];

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private contractTransactionSeriesService: ContractTransactionSeriesService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private transactionSeriesService: TransactionsSeriesService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.contractTransactionSerieFormGroup = this.formBuilder.formGroup<ContractTransactionSerie>(this.contractTransactionSerie) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.contractTransactionSerieId) {
      this.loadContractTransactionSerie(this.config.data.contractTransactionSerieId);
    } else {
      this.contractTransactionSerie.contractId = this.config.data.contractId;
    }
    this.loadTransactionSeries();

    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
  }

  async loadContractTransactionSerie(id: string) {
    this.contractTransactionSerie = await firstValueFrom(this.contractTransactionSeriesService.get(id));
    this.contractTransactionSerieFormGroup.patchValue(this.contractTransactionSerie);
  }

  async loadTransactionSeries() {
    let response = await firstValueFrom(this.transactionSeriesService.all());
    this.transactionSeries = response.data;
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.contractTransactionSerieFormGroup);
    if (valid) {
      this.contractTransactionSerie = Object.assign(this.contractTransactionSerie, this.contractTransactionSerieFormGroup.value);      
      await this.contractTransactionSeriesService.save(this.contractTransactionSerie).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Serie guardada correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar la serie' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar la serie?",
      header: "Eliminar serie",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractTransactionSeriesService.delete(this.contractTransactionSerie.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Serie eliminada correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
